import axios from 'axios'

// Set the search form with values fromn the api
const setApiSearchForm = (apiFormBehavior) => {

    if (!document.querySelector('form#api-search')) {
        return null
    }

    axios.get(`/wp-json/batami/v1/getdata`, {})
        .then(function (res) {
            // inputs to push to
            const cityInput = document.querySelector('#api-search-input-city')
            const areasInput = document.querySelector('#api-search-input-areas')
            const coordinatorsInput = document.querySelector('#api-search-input-coordinators')
            const activitiesInput = document.querySelector('#api-search-fields fieldset')

            const { CityTypes, AreaTypes, Coordiantors, Activities } = res.data.CodeTables
            console.log('Activities', Activities)

            // build HTML
            const citiesHtml = CityTypes
                .map(city => `<option value="${city.Id}" class="search-dropdown__option">${city.Name}</option>`)
                .join('')

            const areasHtml = AreaTypes
                .map(area => `<option value="${area.Id}" class="search-dropdown__option">${area.Name}</option>`)
                .join('')

            const coordinatorsHtml = Coordiantors
                .map(coordinator => `<option value="${coordinator.Id}" class="search-dropdown__option">${coordinator.Name}</option>`)
                .join('')

            const activities = Activities
            const activitiesFathers = activities.filter(activity => activity.FatherId === 0)

            const activitiesHtml = activitiesFathers
                .map(activity => `        
        <div class="search-field">
            <div class="search-field__head">
                <span class="plus-sign plus-sign--active search-field--open">&#43;</span><span class="minus-sign search-field--open">&#45;</span>

                <label for="">
                    <input type="checkbox" value="${activity.Id}" name="Act" class="search-field__service-group api-form__checkbox-group search-checkbox search-checkbox--top">   
                    <h4 class="api-form__topic search-field__topic search-field--open">${activity.Name}</h4>
                </label>
            </div>
            <div class="search-field__options">

            ${activities.map(newActivity => (newActivity.FatherId === activity.Id) ? `
            <label >
                <input type="checkbox" name="Act" value="${newActivity.Id}" class="search-field__service api-form__checkbox search-checkbox">
                <span class="search-field__name">${newActivity.Name}</span> 
            </label>` : '').join('')}

        </div>
            </div>` ).join('')

            const level1 = activities.filter(activity => activity.Level == 1)

            const actHtml = level1
                .map(activity => `        
        <div class="search-field">
            <div class="search-field__head">
                <span class="plus-sign plus-sign--active search-field--open">&#43;</span><span class="minus-sign search-field--open">&#45;</span>

                <label>
                    <input type="checkbox" value="${activity.Id}" name="Act" class="search-field__service-group api-form__checkbox-group search-checkbox search-checkbox--top">   
                    <h4 class="api-form__topic search-field__topic search-field--open">${activity.Name}</h4>
                </label>
            </div>
            <div class="search-field__options">

            ${activities.map(newActivity => (newActivity.FatherId === activity.Id) ? `
            <div class="search-field__head2">
                <span class="plus-sign plus-sign--active search-field--open">&#43;</span><span class="minus-sign search-field--open">&#45;</span>
                <label>
                    <input type="checkbox" name="Act" value="${newActivity.Id}" class="search-field__service api-form__checkbox search-checkbox search-field__service-group api-form__checkbox-group search-checkbox--top">
                    <span class="search-field__name">${newActivity.Name}</span> 
                </label>
            </div>
            <div class="search-field__options2" style="color:red;">
                ${activities.map(newActivity3 => (newActivity3.FatherId === newActivity.Id) ? `
                <label>
                    <input type="checkbox" name="Act" value="${newActivity3.Id}" class="search-field__service api-form__checkbox search-checkbox">
                    <span class="search-field__name">${newActivity3.Name}</span> 
                </label>` : '').join('')}
            </div>` : '').join('')}

        </div>
            </div>` ).join('')


            // append html
            //activitiesInput.insertAdjacentHTML('afterbegin', activitiesHtml)
            activitiesInput.insertAdjacentHTML('afterbegin', activitiesHtml)
            areasInput.insertAdjacentHTML('beforeend', areasHtml)
            cityInput.insertAdjacentHTML('beforeend', citiesHtml)
            coordinatorsInput.insertAdjacentHTML('beforeend', coordinatorsHtml)


            // initialized form behavior (slides and styles)
            apiFormBehavior()

        })
}

export default setApiSearchForm